import styled from "styled-components";

export const SectionHeader = styled.h3(
  (props) => `
    font-weight: 600;
    font-size: ${props.theme.font.custom(22)};
    font-family: ${props.theme.font.fontFamily};
    flex: 14;
    color: #18a160;
    `
);

export const StyledModalHeader = styled.div(
  (props) => `
  display: flex;
  padding: 2rem;
  border-bottom: .1rem solid ${props.theme.colors.goBrandBlue.light};
`
);

export const StyledIcon = styled.div(
  (props) => `
  align-items: flex-end;
  justofy-content: flex-end;
  cursor: pointer;
`
);

export const Styling = styled.div`
  margin: 2rem 2rem 1rem 2rem;
`;

export const StylingDiv = styled.div`
  margin: 2rem 2rem 2rem 2rem;
`;

export const HeaderTxt = styled.p(
  (props) => `
  font-family: ${props.theme.font.fontFamily};
  margin: 2.35rem 28.4rem 1.3rem 0;
  font-size: 1.6rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: ${props.txtAlign ? props.txtAlign : ""};
  color: #2276e3;
`
);

export const LiTxt = styled.p`
  font-family: 'Rubik';
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #777777;
  padding-left: 10px;
`;

export const FooterTxt = styled.p`
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #4f525a;
`;

export const StyledModal = styled.div(
  (props) => `
  display: flex;
  padding: 2rem;
  flex-direction: column;
`
);

export const StylingModal = styled.div`
  margin: 2rem 2rem 1rem 2rem;
`;

export const Bar = styled.div(
  props => 
  `
  display: flex;
  margin: ${props.margin ? props.margin : '1.8rem 0 1.4rem'};
  padding: 1.1rem 11.2rem 1.1rem 1.2rem;
  border-radius: 0.4rem;
  border: solid 0.1rem #d5d5d5;
  cursor: pointer;
  background-color: ${props.bc ? props.bc : '#ffffff'};
  align-items: ${props.ai ? props.ai : ''};
  justify-content: ${props.jc ? props.jc : ''};
`);

export const Bartxt = styled.p`
  margin: 0.2rem 0 0.3rem 1rem;
  font-family: 'Rubik';
  font-size: 1.2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3c3c3c;
`;
export const Btntxt = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  font-family: 'Rubik';
  font-weight: 600;
`;

export const LiWrapper = styled.div`
  display:flex;
  flex-direction: row;
  margin: 1.3rem 0.1rem 1.6rem 0rem;
`;

export const Dot = styled.p`
  width: 6px;
  height: 6px;
  padding: 0.2rem;
  border-radius: 50%;
  margin: 0.6rem 0.6rem 0 0;
  border: solid 1px #000000;
  background-color: #000000;
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  bottom: 2.2rem;
`;

export const ReadMoreTxt = styled.p`
  font-family: 'Rubik';
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2276e3;
  margin: 0.6rem 0.6rem 0 0;
  padding-left: 10px;
`;

export const ListWrapper = styled.div`
  position: relative;
  overflow-y: scroll;
  min-height: 20rem;
  max-height: 42rem;
`;
